import type { Vehicle } from "@/types";
import { vehicleTitle } from "@/lib/format";

export default function SpecsGrid({ vehicle }: { vehicle: Vehicle }) {
  const specs = [
    { icon: "ri-calendar-line", label: "Year", value: vehicle.year ? String(vehicle.year) : "—" },
    { icon: "ri-car-line", label: "Body type", value: vehicle.body_type || vehicle.category || "—" },
    { icon: "ri-settings-3-line", label: "Transmission", value: vehicle.transmission || "—" },
    { icon: "ri-gas-station-line", label: "Fuel", value: vehicle.fuel_type || "—" },
    { icon: "ri-user-3-line", label: "Seats", value: vehicle.seats ? `${vehicle.seats} seats` : "—" },
    { icon: "ri-door-open-line", label: "Doors", value: vehicle.doors ? `${vehicle.doors} doors` : "—" },
    { icon: "ri-map-pin-2-line", label: "Located in", value: vehicle.location || vehicle.city || "—" },
    { icon: "ri-roadster-line", label: "Model", value: vehicleTitle(vehicle.make, vehicle.model) },
  ];

  return (
    <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
      {specs.map((spec) => (
        <div key={spec.label} className="rounded-xl border border-background-200/70 bg-background-100 p-3.5">
          <i className={`${spec.icon} text-lg text-primary-500`}></i>
          <p className="mt-2 text-xs uppercase tracking-wider text-foreground-500">{spec.label}</p>
          <p className="mt-0.5 text-sm font-medium text-foreground-950">{spec.value}</p>
        </div>
      ))}
    </div>
  );
}